var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConMarkerImageSrcSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 51,
    viewBox: "0 0 46 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_59_2869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 20C43 29.0601 36.9757 36.7131 28.7143 39.1718C25.8571 40 23 45 23 45C23 45 20.1429 40 17.2857 39.1718C9.02432 36.7131 3 29.0601 3 20C3 8.9543 11.9543 0 23 0C34.0457 0 43 8.9543 43 20Z",
    fill: "#FF4848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 44.0447C22.977 44.0088 22.9531 43.9717 22.9284 43.9337C22.6099 43.4428 22.1543 42.7784 21.6063 42.0861C21.0594 41.3952 20.4134 40.6675 19.713 40.0554C19.0179 39.448 18.2399 38.9282 17.4267 38.6921C9.37234 36.2942 3.5 28.8322 3.5 20C3.5 9.23045 12.2304 0.5 23 0.5C33.7696 0.5 42.5 9.23045 42.5 20C42.5 28.8323 36.6276 36.2942 28.5732 38.6921C27.7601 38.9282 26.982 39.448 26.2871 40.0554C25.5866 40.6675 24.9406 41.3952 24.3937 42.0861C23.8457 42.7784 23.3901 43.4428 23.0716 43.9337C23.0469 43.9717 23.023 44.0088 23 44.0447Z",
    stroke: "#FF4848"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.171 11.9873H25.6313V11.6284C25.6313 10.8846 25.0124 10.2778 24.2538 10.2778H21.8009C21.0424 10.2778 20.4235 10.8846 20.4235 11.6284V11.9873H15.8875C15.1517 11.9873 14.5554 12.5719 14.5554 13.2935V27.0029C14.5554 27.7245 15.1517 28.3091 15.8875 28.3091H16.4272V29.4414C16.4272 30.1222 16.9932 30.6773 17.6876 30.6773H18.3933C19.0876 30.6773 19.6537 30.1222 19.6537 29.4414V28.3091H26.4049V29.4414C26.4049 30.1222 26.9709 30.6773 27.6653 30.6773H28.371C29.0653 30.6773 29.6314 30.1222 29.6314 29.4414V28.3091H30.171C30.9069 28.3091 31.5031 27.7245 31.5031 27.0029V13.2935C31.5031 12.5756 30.9069 11.9873 30.171 11.9873ZM20.8009 11.6284C20.8009 11.0881 21.25 10.6478 21.8009 10.6478H24.2538C24.8048 10.6478 25.2539 11.0881 25.2539 11.6284V11.9873H20.8009V11.6284ZM19.2763 29.4414C19.2763 29.9187 18.8801 30.3072 18.3933 30.3072H17.6876C17.2008 30.3072 16.8045 29.9187 16.8045 29.4414V28.3091H19.2801V29.4414H19.2763ZM29.254 29.4414C29.254 29.9187 28.8578 30.3072 28.371 30.3072H27.6653C27.1785 30.3072 26.7822 29.9187 26.7822 29.4414V28.3091H29.2578V29.4414H29.254ZM31.1258 27.0029C31.1258 27.521 30.6956 27.9391 30.171 27.9391H29.6314H26.4011H19.6537H16.4234H15.8838C15.3554 27.9391 14.929 27.521 14.929 27.0029V13.2935C14.929 12.7754 15.3592 12.3573 15.8838 12.3573H20.4235H25.6313H30.1672C30.6956 12.3573 31.122 12.7754 31.122 13.2935V27.0029H31.1258Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6787 19.0501V15.6286C28.6787 15.0128 28.3061 14.5147 27.8515 14.5147H18.2074C17.7501 14.5147 17.3802 15.0166 17.3802 15.6286V19.0501C17.3802 19.666 17.7529 20.164 18.2074 20.164H27.8515C28.3089 20.164 28.6787 19.666 28.6787 19.0501ZM17.6626 19.0501V15.6286C17.6626 15.2218 17.9082 14.8949 18.2074 14.8949H27.8515C28.1536 14.8949 28.3964 15.2256 28.3964 15.6286V19.0501C28.3964 19.4569 28.1508 19.7838 27.8515 19.7838H18.2074C17.9082 19.7838 17.6626 19.4569 17.6626 19.0501Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3377 23.7319C17.5414 23.7319 16.8923 24.3683 16.8923 25.1491C16.8923 25.9298 17.5414 26.5663 18.3377 26.5663C19.1339 26.5663 19.783 25.9298 19.783 25.1491C19.783 24.3683 19.1339 23.7319 18.3377 23.7319ZM18.3377 26.1963C17.749 26.1963 17.2697 25.7263 17.2697 25.1491C17.2697 24.5718 17.749 24.1019 18.3377 24.1019C18.9264 24.1019 19.4056 24.5718 19.4056 25.1491C19.4056 25.7263 18.9264 26.1963 18.3377 26.1963Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7211 23.7319C26.9248 23.7319 26.2758 24.3683 26.2758 25.1491C26.2758 25.9298 26.9248 26.5663 27.7211 26.5663C28.5173 26.5663 29.1664 25.9298 29.1664 25.1491C29.1664 24.3683 28.5211 23.7319 27.7211 23.7319ZM27.7211 26.1963C27.1324 26.1963 26.6531 25.7263 26.6531 25.1491C26.6531 24.5718 27.1324 24.1019 27.7211 24.1019C28.3098 24.1019 28.789 24.5718 28.789 25.1491C28.789 25.7263 28.3098 26.1963 27.7211 26.1963Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_59_2869",
    x: 0,
    y: 0,
    width: 46,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_59_2869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_59_2869",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConMarkerImageSrcSelect);
export default __webpack_public_path__ + "static/media/conMarkerImageSrc_select.2bd1bc10e1ecb170ff2cf8bca0db139e.svg";
export { ForwardRef as ReactComponent };